import React, { useRef, useState } from "react";
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Stack from '@mui/joy/Stack';
import CardActions from '@mui/joy/CardActions';
import CardOverflow from '@mui/joy/CardOverflow';
import 'react-international-phone/style.css';
import { Button } from "primereact/button";
import { PhoneInput } from "react-international-phone";
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import { legislationAdd, legislationUpdate } from "../../service/legislationService";
import { FileUpload } from "primereact/fileupload";
import MultiDropdownApi from "../../components/MultiDropdownApi";

export default function LegislationAdd(modalProps: any) {

  console.log("modalProps == ",modalProps);
  const [industry, setIndustry] = useState(modalProps?.record?.industry || []);
  const [heading, setHeading] = useState(modalProps?.record?.heading || "");
  const [title, setTitle] = useState(modalProps?.record?.title || "");
  const [description, setDescription] = useState(modalProps?.record?.description || "");
  const [descriptionError, setDescriptionError] = useState(false);
  const [link, setLink] = useState(modalProps?.record?.link || "");
  const [linkError, setLinkError] = useState(false);

  async function addInformation() {
    const errorDescription = !description || description === '';
    // const errorLink = !link || link === '';
    setDescriptionError(errorDescription);
    // setLinkError(errorLink);
    if (errorDescription) {
      modalProps.toast.current.show({ severity: 'warn', summary: 'Please enter all required fields', life: 3000 });
      return;
    }
    modalProps.setGlobalLoading(true);
    if (modalProps.id) {
      legislationUpdate(modalProps.id, {
        description, link, heading, title, industry
      }).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Legislation Updated Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      })
    } else {
      legislationAdd({
        description, link, heading, title, industry
      }).then((r: any) => {
        modalProps.toast.current.show({ severity: 'success', summary: 'Legislation Created Successfully', life: 3000 });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      })
    }
  }

  return (
    <React.Fragment>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Heading</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="Heading" value={heading} onChange={e => setHeading(e.target.value)} />
            </FormControl>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Title</FormLabel>
            <FormControl
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} />
            </FormControl>
          </Stack>
        </Stack>
      </Stack>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Description<div style={{ color: 'red' }}>*</div></FormLabel>
            <FormControl
              error={descriptionError}
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="Description" value={description} onChange={e => setDescription(e.target.value)} />
            </FormControl>
          </Stack>
        </Stack>
      </Stack>
      <Stack spacing={1}>
        <MultiDropdownApi showAll={true} required={true} apiPath='industry' optionLabel="name" optionValue='id' label='Industry' selectedData={industry} setSelectedData={setIndustry} />
      </Stack>
      <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Link</FormLabel>
            <FormControl
              error={linkError}
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <Input size="sm" placeholder="Link" value={link} onChange={e => setLink(e.target.value)} />
            </FormControl>
          </Stack>
        </Stack>
      </Stack>
      {/* <Stack
        direction="row"
        spacing={3}
        sx={{ display: { xs: 'none', md: 'flex' }, my: 1 }}
      >
        <Stack spacing={2} sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
          <Stack spacing={1}>
            <FormLabel>Upload</FormLabel>
            <FormControl
              error={linkError}
              sx={{ display: { sm: 'flex-column', md: 'flex-row' }, gap: 2 }}
            >
              <FileUpload mode="basic" name="demo[]" url="/api/upload" accept="image/*" maxFileSize={1000000} />
            </FormControl>
          </Stack>
        </Stack>
      </Stack> */}
      <CardOverflow style={{ width: '100%' }} sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: 'flex-end', pt: 2 }}>
          <Button type="button" icon="pi pi-save" label="Save" className="p-button-outlined" size="small" style={{ position: 'absolute', fontSize: 'small', right: 0, color: "#2dd36f" }} onClick={() => addInformation()} />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}